export default {
  title: 'merchant rút tiền',
  steps: {
    one: 'chọn loại ví',
    two: 'trình xác thực google',
    three: 'mã xác minh'
  },
  label: {
    bankId: 'ID ngân hàng',
    googleDynamicCaptcha: 'trình xác thực google',
    payPass: 'mật khẩu thanh toán',
    walletType: 'loại ví',
    withdrawAmount: 'số tiền',
    amountTotal: 'Tổng số dư',
    blanceAmount: 'số dư còn lại'
  },
  rules: {
    bankId: {
      required: 'ID ngân hàng bắt buộc chọn'
    },
    googleDynamicCaptcha: {
      required: 'mã xác minh google không được để trống',
      type: 'mã xác minh google bắt buộc là số',
      max: 'mã xác minh gồm 6 chữ số'
    },
    payPass: {
      required: 'mật khẩu thanh toán không được bỏ trống'
    },
    walletType: {
      required: 'Loại ví bắt buộc chọn'
    },
    withdrawAmount: {
      required: 'số tiền không được để trống',
      type: 'số tiền phải điền dạng số',
      min: 'số tiền rút phải lớn hơn 1000.000',
      max: 'Số tiền rút không được lớn hơn số dư'
    }
  }
};



// WEBPACK FOOTER //
// ./src/i18n/lang/vi/merchantdeposit.js